import React, { useEffect, useState } from "react";
import styles from "../../../src/assets/scss/Billing/InvoiceDesign.module.scss";
import html2canvas from "html2canvas";
import { BaseURL } from "../../lib/api";
import { useLazyGetreportBillQuery, useGetUserByIdQuery } from "../../slices/admin/admin";
import { getUserInfo } from "../../utils/user.util";

const formatCurrency = (v) => {
    if (v == null) return "₹0.00";
    return "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatDate = (iso) => {
    const d = iso ? new Date(iso) : new Date();
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const formatTime = (iso) => {
    const d = iso ? new Date(iso) : new Date();
    return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true });
};

const InvoiceDesignReports = ({ data = {}, mode = "thermal" }) => {

    //console.log(data,"data in invoice design");

    const items = data.items || [];


    const [triggerGetBillPdf] = useLazyGetreportBillQuery();

    // ✅ Handle both absolute & relative logo URLs cleanly
const resolveImageUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http")
    ? path
    : `${BaseURL.replace(/\/$/, "")}/${path.replace(/^\/+/, "")}`;
};


    // Fetch user info
    const localUser = getUserInfo();
    const userId = localUser?._id;
    const { data: userData } = useGetUserByIdQuery(userId, { skip: !userId });

    const [printerLogo, setPrinterLogo] = useState(null);
    const [printerOption, setPrinterOption] = useState(80); // default 80mm

    useEffect(() => {
        if (userData?.result?.length > 0) {
            const user = userData.result[0];
            // if (user.isPrintLogo && user.store?.logo) {
            //     setPrinterLogo(`${BaseURL}/${user.store?.logo}`);
            // }
            if (user.isPrintLogo && user.store?.logo) {
    const logoPath = resolveImageUrl(user.store.logo);
    setPrinterLogo(logoPath);
}

            if (user.printerOption) setPrinterOption(user.printerOption);
        }
    }, [userData]);

    const subtotal = items.reduce((s, it) => s + Number(it.totalPrice || 0), 0);
    const paymentMethods = data?.paymentMethod;
    const logistic = Number(data.logisticCharge || 0);
    const handle = Number(data.handleCharge || 0);
    const commission = Number(data.commissionAmount || 0);
    const commissionPercentage = data.percentage || null;
    const apiTotal = Number(data.totalAmount || subtotal + logistic + handle);

    // WhatsApp share
    const handleShareWhatsApp = async () => {
        try {
            if (!data._id) return alert("Bill ID not found!");
            const response = await triggerGetBillPdf(data._id).unwrap();
            const pdfUrl = response?.pdfUrl || `${BaseURL}billing/print/reportBill/${data._id}`;
            const message = `Hi ${data.customer?.firstName || ""}, here is your invoice:\n${pdfUrl}`;
            const waUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
            window.open(waUrl, "_blank");
        } catch (err) {
            console.error("Error sharing PDF:", err);
            alert("Failed to share invoice.");
        }
    };

    // Thermal Print
    // const handlePrint = async () => {
    //     const invoiceElement = document.getElementById("print-area");
    //     if (!invoiceElement) return;

    //     const buttons = invoiceElement.querySelectorAll(".addBtn, .noPrint");
    //     buttons.forEach((btn) => (btn.style.display = "none"));

    //     const canvas = await html2canvas(invoiceElement, { scale: 2 });
    //     const imgData = canvas.toDataURL("image/png");

    //     buttons.forEach((btn) => (btn.style.display = ""));

    //     const printWindow = window.open("", "_blank");
    //     printWindow.document.write(`
    //   <html>
    //     <head>
    //       <title>Invoice</title>
    //       <style>
    //         body, html { margin:0; padding:0; background:#fff; }
    //         img { max-width:100%; height:auto; display:block; margin:auto; }
    //       </style>
    //     </head>
    //     <body>
    //       <img src="${imgData}" />
    //       <script>
    //         window.onload = function() { window.print(); window.onafterprint = function(){ window.close(); } }
    //       </script>
    //     </body>
    //   </html>
    // `);
    //     printWindow.document.close();
    // };

    const handlePrint = async () => {
        const invoiceElement = document.getElementById("print-area");
        if (!invoiceElement) return;

        // Hide buttons before screenshot
        const buttons = invoiceElement.querySelectorAll(".addBtn, .noPrint");
        buttons.forEach((btn) => (btn.style.display = "none"));

        // Wait for all images to load
        const images = invoiceElement.querySelectorAll("img");
        await Promise.all(
            Array.from(images).map(
                (img) =>
                    new Promise((resolve) => {
                        if (img.complete) resolve(true);
                        else img.onload = img.onerror = () => resolve(true);
                    })
            )
        );

        // Generate canvas
        const canvas = await html2canvas(invoiceElement, { scale: 2, useCORS: true });
        const imgData = canvas.toDataURL("image/png");

        // Restore buttons
        buttons.forEach((btn) => (btn.style.display = ""));

        // Open print window
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
        <html>
            <head>
                <title>Invoice</title>
                <style>
                    body, html { margin:0; padding:0; background:#fff; }
                    img { max-width:100%; height:auto; display:block; margin:auto; }
                </style>
            </head>
            <body>
                <img src="${imgData}" />
                <script>
                    window.onload = function() { window.print(); window.onafterprint = function(){ window.close(); } }
                </script>
            </body>
        </html>
    `);
        printWindow.document.close();
    };


    return (
        <div className={styles.overlay}>
            <div className={styles.invoiceBox} id="print-area">
                <div className={styles.header}>
                    {printerLogo ? (
                        // <img
                        //     src={printerLogo}
                        //     alt="Logo"
                        //     className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`}
                        // />
                        <img
    src={printerLogo}
    alt="Logo"
    onError={(e) => (e.target.style.display = "none")}
    className={`${styles.printLogo} ${printerOption === 58 ? styles.logo58 : styles.logo80}`}
/>

                    ) : (
                        <h2>
                            {data.source === "Billing"
                                ? "Receivable Bill"
                                : data.source === "PayableBill"
                                    ? "Payable Bill"
                                    : "Bill"}
                        </h2>
                    )}


                    {/* Store address below logo */}
                    {userData?.result?.[0]?.store && (
                        <div className={styles.storeInfo}>
                            <div className={styles.storeName}>
                                {userData.result[0].store.storeName}
                            </div>
                            {userData.result[0].store.gst && (
                                <div className={styles.storeAddress}>

                                    <div className={styles.storeGST}>
                                        GST : {userData.result[0].store.gst}
                                    </div>
                                </div>
                            )}
                            <div className={styles.storeAddress}>
                                {[
                                    userData.result[0].store.address,
                                    userData.result[0].store.address1,
                                    // userData.result[0].store.address2,
                                    userData.result[0].store.city
                                ]
                                    .filter(Boolean)
                                    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                                    .join(", ")}
                            </div>
                            <div className={styles.storeAddress}>
                                {[
                                    userData.result[0].store.state,
                                    userData.result[0].store.pincode
                                ]
                                    .filter(Boolean)
                                    .map(part => typeof part === "string" ? part.charAt(0).toUpperCase() + part.slice(1) : part)
                                    .join(" - ")}
                            </div>

                        </div>
                    )}
                    <h2>
                        {data.source === "Billing"
                            ? "Receivable Bill"
                            : data.source === "PayableBill"
                                ? "Payable Bill"
                                : "Bill"}
                    </h2>
                </div>

                {/* Customer & Invoice Info */}
                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        <div>
                            <span className={styles.label}>Name</span><span className={styles.labelsname}> : {data.customerId?.firstName || "-"}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Phone</span><span className={`${styles.labels} notranslate`}> : {data.customerId?.phone || "-"}</span>
                        </div>
                    </div>
                    {/* <div className={styles.right}>
                        <div>
                            <span className={styles.label}>Bill No</span><span className={styles.labels}> : {data.receiptNo || "-"}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Date</span><span className={styles.labels}> : {formatDate(data.createdAt)}</span>
                        </div>
                        <div>
                            <span className={styles.label}>Time</span> <span className={styles.labels}> : {formatTime(data.createdAt)}</span>
                        </div>
                    </div> */}
                </div>
                <hr className={styles.dotted} />
                <div className={styles.infoRow}>
                    <div className={styles.left}>
                        <div className={styles.right}>
                            <div>
                                <span className={styles.label}>Bill No</span><span className={`${styles.labels} notranslate`}> : {data.receiptNo || "-"}</span>
                            </div>
                            <div>
                                <span className={styles.label}>Date</span><span className={`${styles.labels} notranslate`}> : {formatDate(data.createdAt)}</span>
                            </div>
                            <div>
                                <span className={styles.label}>Time</span> <span className={`${styles.labels} notranslate`}> : {formatTime(data.createdAt)}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <hr className={styles.dotted} />
                {/* <hr className={styles.dottedSmallmargin} /> */}


                {/* Items Table */}
                <table className={styles.invoiceTable}>
                    <thead>
                        <tr>
                            <th className={styles.itemHeader}>Item Name</th>
                            <th className={styles.qtyHeader}>Quantity</th>
                            <th className={styles.priceHeader}>Price</th>
                            <th className={styles.totalHeader}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((it, idx) => (
                            <tr key={idx}>
                                <td className={styles.itemCell}>{it.productName || "-"}</td>
                                <td className={`${styles.qtyCell} notranslate`}>{it.productQuantity || 0}</td>
                                <td className={`${styles.priceCell} notranslate`}>{formatCurrency(it.price)}</td>
                                <td className={`${styles.totalCell} notranslate`}>{formatCurrency(it.totalPrice)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* <hr className={styles.dotted} /> */}
                <hr className={styles.dottedSmallmargin} />


                {/* Summary */}
                <div className={styles.summary}>
                    <div className={styles.summaryRow}>
                        <div className={styles.qtys}>Items/Qty :</div>
                        <div className={`${styles.qtys} notranslate`}>
                            {items.length} / {items.reduce((s, it) => s + Number(it.productQuantity || 0), 0)}
                        </div>
                    </div>

                    {/* <div className={styles.totals}>
                        <div className={styles.totalRow}>
                            <div>Payment Type:</div>
                            <div className={styles.payable}>{paymentMethods}</div>
                        </div>
                        <div className={styles.totalRow}>
                            <div>Subtotal:</div>
                            <div className={styles.totalAmount}>{formatCurrency(subtotal)}</div>
                        </div>
                        {commission > 0 && (
                            <div className={styles.totalRow}>
                                <div>Commission {commissionPercentage ? `(${commissionPercentage}%)` : ""}:</div>
                                <div className={styles.totalAmount}>-{formatCurrency(commission)}</div>
                            </div>
                        )}
                        {handle > 0 && (
                            <div className={styles.totalRow}>
                                <div>Handling Charge:</div>
                                <div className={styles.totalAmount}>-{formatCurrency(handle)}</div>
                            </div>
                        )}
                        {logistic > 0 && (
                            <div className={styles.totalRow}>
                                <div>Logistic Charge:</div>
                                <div className={styles.totalAmount}>-{formatCurrency(logistic)}</div>
                            </div>
                        )}
                        <div className={styles.totalRow}>
                            <div>Total Amount:</div>
                            <div className={styles.grandAmount}>{formatCurrency(apiTotal)}</div>
                        </div>
                    </div> */}
                    <div className={styles.totals}>
                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}>
                                <p className={styles.fixwidth}>Payment Type</p><span> : </span>
                            </div>
                            <div className={styles.payable}>{paymentMethods}</div>
                        </div>

                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}>
                                <p className={styles.fixwidth}>Subtotal</p><span> : </span>
                            </div>
                            <div className={`${styles.totalAmount} notranslate`}>{formatCurrency(subtotal)}</div>
                        </div>

                        {commission > 0 && (
                            <div className={styles.totalRow}>
                                <div className={styles.fixwidths}>
                                    <p className={styles.fixwidth}>
                                        Commission {commissionPercentage ? `(${commissionPercentage}%)` : ""}
                                    </p><span> : </span>
                                </div>
                                <div className={`${styles.totalAmount} notranslate`}>-{formatCurrency(commission)}</div>
                            </div>
                        )}

                        {handle > 0 && (
                            <div className={styles.totalRow}>
                                <div className={styles.fixwidths}>
                                    <p className={styles.fixwidth}>Handling Charge</p><span> : </span>
                                </div>
                                <div className={`${styles.totalAmount} notranslate`}>-{formatCurrency(handle)}</div>
                            </div>
                        )}

                        {logistic > 0 && (
                            <div className={styles.totalRow}>
                                <div className={styles.fixwidths}>
                                    <p className={styles.fixwidth}>Logistic Charge</p><span> : </span>
                                </div>
                                <div className={`${styles.totalAmount} notranslate`}>-{formatCurrency(logistic)}</div>
                            </div>
                        )}
                        <hr className={styles.dottedSmallmarginno} />

                        <div className={styles.totalRow}>
                            <div className={styles.fixwidths}>
                                <p className={styles.fixwidth}>Total Amount</p><span> : </span>
                            </div>
                            <div className={`${styles.grandAmount} notranslate`}>{formatCurrency(apiTotal)}</div>
                        </div>
                    </div>


                    <div className={styles.footer}>
                        {mode === "thermal" && (
                            <button className={`${styles.addBtn} noPrint`} onClick={handlePrint}>Print</button>
                        )}
                        {mode === "whatsapp" && (
                            <button className={styles.addBtn} onClick={handleShareWhatsApp}>Share on WhatsApp</button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDesignReports;
